import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 73",
  "use": "icon-Group 73-usage",
  "viewBox": "0 0 55 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 55 24\" id=\"icon-Group 73\">\n  <g id=\"icon-Group 73_Group_73\" data-name=\"Group 73\" transform=\"translate(-868 -4202)\">\n    <path id=\"icon-Group 73_Polygon_4\" data-name=\"Polygon 4\" d=\"M4,0,8,7H0Z\" transform=\"translate(923 4212.5) rotate(90)\" fill=\"currentColor\" />\n    <text id=\"icon-Group 73_more\" transform=\"translate(868 4221)\" fill=\"currentColor\" font-size=\"16\" font-family=\"NotoSansCJKtc-Bold, Noto Sans CJK TC\" font-weight=\"700\"><tspan x=\"0\" y=\"0\">more</tspan></text>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 73.svg
// module id = QSOG
// module chunks = 3